export default __webpack_public_path__ + "static/media/Emily  Taylor.354d2bc0.jpg";